import { generateColors } from "@mantine/colors-generator"
import { MantineColorsTuple } from "@mantine/core"

export const buildPalette = (color: string): MantineColorsTuple => {
  return generateColors(color)
}

export const REDIRECT_MAP: Record<string, URL> = {
  "v2d-lingerie": new URL(
    "https://v2dlingerie.com/collections/tous-les-produits"
  ),
}
